import React, { useRef } from 'react';

import root from 'react-shadow';
import AtcuiProviders from './AtcuiProviders';

export default function BonnetWebComponent(props) {
    const ref = useRef();

    return (
        <root.div>
            <div
                className="web-container"
                ref={ref}
            >
                <AtcuiProviders
                    {...props}
                    containerRef={ref}
                >
                    {props?.children}
                </AtcuiProviders>
                {/*
                    <input> is needed for the web component to recognize any potential form updates.
                    It's dumb.  We know.  We are sorry.
                    Possible related issue: https://github.com/Wildhoney/ReactShadow/issues/116
                */}
                <input style={{ display: 'none' }} />
            </div>
        </root.div>
    );
}
